<!--工人总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Total Main Con Worker (By Trade)
    </h1>
    <div v-if="dataNotNull" key="1" class="workerDiv" style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import echarts from 'echarts'

export default {
  props: ['project_id'],
  name: "workers",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "workers",
      dataNotNull: true
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    analysisResult(result) {
      var legends = [
        'Scaffold Supervisor',
        'Scaffold Erector',
        'Site Supervisor',
        'First Aider',
        'Workers (Wood)',
        'Workers (Formwork)',
        'Lifting Supervisor',
        'Rigger Man',
        'Signal Man'
      ]

      var workers = [
        {name: 'Scaffold Supervisor', value: 0},
        {name: 'Scaffold Erector', value: 0},
        {name: 'Site Supervisor', value: 0},
        {name: 'First Aider', value: 0},
        {name: 'Workers (Wood)', value: 0},
        {name: 'Workers (Formwork)', value: 0},
        {name: 'Lifting Supervisor', value: 0},
        {name: 'Rigger Man', value: 0},
        {name: 'Signal Man', value: 0}
      ]


      var others = 0

      for (var i in result) {
        var type = result[i].role_type
        var count = result[i].count
        var index = legends.indexOf(type)
        if (index != -1) {
          workers.splice(index, 1, {name: type, value: count})
        } else {
          others += parseInt(count)
        }
      }
      workers.push({name: 'Others', value: others})
      legends.push('Others')

      return {legends: legends, workers: workers}
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.myChart = echarts.init(document.querySelector('.workerDiv .container1'))
    this.myChart.setOption({
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)",
        textStyle: {
          fontSize: '40'
        }
      },
      legend: {
        orient: 'vertical',
        x: 'right',
        left: '53%',
        top: 'middle',
        itemGap: 24,
        itemHeight: '28',
        itemWidth: 80,
        textStyle: {
          color: '#FFF',
          fontSize: '36'
        },
        data: []
      },
      series: [{
        name: 'Worker',
        data: [],
        type: 'pie',
        hoverOffset: 5,
        radius: ['45%', '65%'],
        center: ['25%', '50%'],
        label: {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              if (params.value > 0) {
                return params.value
              } else {
                return ''
              }
            },
            textStyle: {
              fontSize: '36',
            }
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '48',
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },

        itemStyle: {
          normal: {
            color: function (params) {
              return that.color[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            borderWidth: 1
          }
        }
      }],
    })
    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      project_id: this.my_project_id,
      type: '0',
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjStaff", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        var data = this.analysisResult(result)
        this.myChart.setOption({
          legend: {
            data: data.legends,
            itemGap: 24,
          },
          series: [{
            data: data.workers
          }]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })
  }
}

</script>

<style lang="stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/workers.vue